/**
 * Layout Constants
 * This file contains all the layout constants used throughout the application
 */

export const APP_URL_LOCAL =
  process.env.REACT_APP_APP_URL_LOCAL || 'http://localhost:3001';
export const APP_URL_STAGING = 'https://dai-app.vmtsd.com';
export const APP_URL_PROD_TARGET = 'https://app.dai.delta-asia.com.mo';

const isStaging =
  typeof window !== 'undefined' &&
  window.location.hostname === 'dai-app.vmtsd.com';

export const APP_URL_PRODUCTION = isStaging
  ? APP_URL_STAGING
  : APP_URL_PROD_TARGET;

export const API_URL_LOCAL =
  process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:3001/insurance';
export const API_URL_STAGING = 'https://dai-api.vmtsd.com/insurance';
export const API_URL_PROD_TARGET =
  'https://api.dai.delta-asia.com.mo/insurance';

export const API_URL_PRODUCTION = isStaging
  ? API_URL_STAGING
  : API_URL_PROD_TARGET;

export const SITE_TITLE = 'Delta Asia Online Application';

export const DEBUG = false; // true / false

export const TEST_MODE = true; // true / false

export const TIMEZONE = 'Asia/Hong_Kong';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_LANGUAGE = 'tc';

export const MAX_RETURN_DAYS = 181;

// Minimum advance booking hours (48 hours before departure/effective date)
export const MIN_ADVANCE_HOURS = 48;

export const MAX_BUILDING_AGE_INPUT_LIMIT = 40;
export const MAX_FLOOR_AREA_INPUT_LIMIT = 6000;

export const CURRENCY = 'MOP';

export const MACAU_GEOS = [
  'Santo António',
  'São Lázaro',
  'São Lourenço',
  'Sé',
  'Nossa Senhora de Fátima',
  'Nossa Senhora do Carmo',
  'São Francisco Xavier',
];

/**
 * Age Requirements for Insured Persons
 * - Adult insured (self, spouse, parent): must be 18 years old or above
 * - Child insured: must be 180 days to 23 years old
 * 
 * Note: Use years/days values with moment.js for accurate calculation
 * Display strings are translation keys - use __() when displaying in UI
 */
export const AGE_REQUIREMENTS = {
  adult: {
    minAgeYears: 18, // Use with moment().subtract(18, 'years') for accuracy
    minAgeDisplayKey: '18 years', // Translation key
  },
  child: {
    minAgeDays: 180, // 180 days
    maxAgeYears: 23, // Use with moment().subtract(23, 'years') for accuracy
    minAgeDisplayKey: '180 days', // Translation key
    maxAgeDisplayKey: '23 years', // Translation key
  },
};

export const IDENTITY_TYPE = [
  {
    value: 'macau_id_card',
    label: 'Macau ID Card',
  },
  {
    value: 'passport',
    label: 'Passport',
  },
  {
    value: 'non_resident_worker_id',
    label: "Non-resident Worker's Identification Card",
  },
  {
    value: 'other',
    label: 'Other',
  },
];

/**
 * Source of business - "How did you hear about our travel insurance product?"
 * Selecting SOURCE_OF_BUSINESS_OTHER reveals a free-text field for the answer.
 * Values are stable codes; labels go through __() for display.
 */
export const SOURCE_OF_BUSINESS_OTHER = 'other';

export const SOURCE_OF_BUSINESS = [
  {
    value: 'social_media',
    label: 'Social Media',
  },
  {
    value: 'search_engine',
    label: 'Search Engine',
  },
  {
    value: 'referral',
    label: 'Friend / Referral',
  },
  {
    value: 'advertisement',
    label: 'Advertisement',
  },
  {
    value: 'partner_agency',
    label: 'Partner / Agency',
  },
  {
    value: SOURCE_OF_BUSINESS_OTHER,
    label: 'Others',
  },
];

/**
 * Cloudflare Turnstile Configuration
 * Site keys for different environments
 * @see https://developers.cloudflare.com/turnstile/
 */
export const CF_TURNSTILE_SITE_KEY_LOCAL = '1x00000000000000000000AA'; // Cloudflare test key (always passes)
export const CF_TURNSTILE_SITE_KEY_STAGING = '0x4AAAAAACK3aGE4l-gATn81'; // Add your staging site key here
export const CF_TURNSTILE_SITE_KEY_PROD = '0x4AAAAAACK3aGE4l-gATn81'; // Add your production site key here

const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';
export const CF_TURNSTILE_SITE_KEY = isLocal
  ? CF_TURNSTILE_SITE_KEY_LOCAL
  : isStaging
  ? CF_TURNSTILE_SITE_KEY_STAGING
  : CF_TURNSTILE_SITE_KEY_PROD;
